import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postResetPassword } from '../../../api';

export const securityAuthenticationResetPasswordPostAsyncSlice = createPostAsyncSlice({
	name: 'SecurityAuthenticationResetPassword',
	receive: true,
	request: true,
	requestHandler: postResetPassword
});
